import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./MyBookings.css";

class MyBookings extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      bookings: [],
      loading: true,
      error: null,

      // Review Popup State
      showReviewPopup: false,
      selectedReviewBooking: null,
      reviewText: "",

      // Dynamic Rating Criteria State (#1 Guest Criteria)
      ratingCriteria: [
        { id: 1787314725651, label: "Cleanliness", value: "5" },
        { id: 1787346727450, label: "Room Quality", value: "5" },
        { id: 1787314725652, label: "Facilities", value: "5" },
        { id: 1787314725653, label: "Service", value: "5" },
        { id: 1787314725654, label: "Check-in Experience", value: "5" },
        { id: 1787314725655, label: "Communication", value: "5" },
      ],
      newCriteriaLabel: "",

      comments: [],
      loadingComments: false,
      submittingReview: false,
    };
  }

  componentDidMount() {
    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    if (
      !web_user_id ||
      web_user_id === "null" ||
      web_user_id === "undefined" ||
      String(web_user_id).trim() === ""
    ) {
      window.location.replace("/searchresultmobile");
      return;
    }
    this.fetchBookings();
  }

  fetchBookings = async () => {
    try {
      this.setState({
        loading: true,
        error: null,
      });

      const web_user_id =
        localStorage.getItem("web_user_id") ||
        sessionStorage.getItem("web_user_id");

      if (!web_user_id) {
        this.setState({
          bookings: [],
          loading: false,
          error: "User session not found.",
        });
        return;
      }

      const response = await axios.get(`/bookings_data/${web_user_id}`);
      const data = response?.data?.data;

      if (!data) {
        this.setState({
          bookings: [],
          loading: false,
        });
        return;
      }

      const backendBookings = Array.isArray(data) ? data : [data];
      const formattedBookings = backendBookings.map((booking) => ({
        id: booking.id || "N/A",
        post_id: booking.post_id || booking.id || "N/A",
        title: booking.title || "N/A",
        checkin_date: booking.checkin_date || "N/A",
        checkout_date: booking.checkout_date || "N/A",
        adults: booking.adults || "N/A",
        booking_date: booking.booking_date || "N/A",
        payment_status: booking.payment_status || "N/A",
        sales_price:
          booking.sales_price !== undefined && booking.sales_price !== null
            ? booking.sales_price
            : "N/A",
        booking_status: booking.booking_status || "Pending",
      }));

      this.setState({
        bookings: formattedBookings,
        loading: false,
      });
    } catch (error) {
      console.error("Bookings fetch error:", error);
      this.setState({
        bookings: [],
        loading: false,
        error: "Unable to load your bookings.",
      });
    }
  };

  // =========================================================
  // REVIEW & STAR RATING ACTIONS
  // =========================================================

  openReviewPopup = (booking) => {
    this.setState(
      {
        selectedReviewBooking: booking,
        showReviewPopup: true,
        reviewText: "",
        ratingCriteria: [
          { id: 1787314725651, label: "Cleanliness", value: "5" },
          { id: 1787346727450, label: "Room Quality", value: "5" },
          { id: 1787314725652, label: "Facilities", value: "5" },
          { id: 1787314725653, label: "Service", value: "5" },
          { id: 1787314725654, label: "Check-in Experience", value: "5" },
          { id: 1787314725655, label: "Communication", value: "5" },
        ],
        newCriteriaLabel: "",
        comments: [],
      },
      () => {
        const postId = booking.post_id || booking.id;
        const bookingId = booking.id;
        this.fetchComments(postId, bookingId);
      }
    );
  };

  closeReviewPopup = () => {
    this.setState({
      selectedReviewBooking: null,
      showReviewPopup: false,
    });
  };

  handleReviewTextChange = (e) => {
    this.setState({ reviewText: e.target.value });
  };

  handleStarClick = (id, ratingValue) => {
    this.setState((prevState) => ({
      ratingCriteria: prevState.ratingCriteria.map((item) =>
        item.id === id ? { ...item, value: String(ratingValue) } : item
      ),
    }));
  };

  handleNewCriteriaChange = (e) => {
    this.setState({ newCriteriaLabel: e.target.value });
  };

  handleAddCriteria = () => {
    const { newCriteriaLabel, ratingCriteria } = this.state;
    if (!newCriteriaLabel.trim()) return;

    const newItem = {
      id: Date.now(),
      label: newCriteriaLabel.trim(),
      value: "5",
    };

    this.setState({
      ratingCriteria: [...ratingCriteria, newItem],
      newCriteriaLabel: "",
    });
  };

  handleRemoveCriteria = (id) => {
    this.setState((prevState) => ({
      ratingCriteria: prevState.ratingCriteria.filter((item) => item.id !== id),
    }));
  };

  fetchComments = async (postId, bookingId) => {
    this.setState({ loadingComments: true });
    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    try {
      const response = await axios.get(
        `/get_all_comments_mobile_by_post_id?post_id=${postId}&booking_id=${bookingId}&customer_id=${web_user_id}&user_type=guest`
      );
      if (
        response?.data?.status === "success" &&
        Array.isArray(response.data.data)
      ) {
        this.setState({ comments: response.data.data });
      } else {
        this.setState({ comments: [] });
      }
    } catch (error) {
      console.error("Fetch comments error:", error);
      this.setState({ comments: [] });
    } finally {
      this.setState({ loadingComments: false });
    }
  };

  submitReview = async () => {
    const { selectedReviewBooking, reviewText, ratingCriteria } = this.state;
    if (!reviewText.trim()) return;

    const web_user_id =
      localStorage.getItem("web_user_id") ||
      sessionStorage.getItem("web_user_id");

    const postId = selectedReviewBooking.post_id || selectedReviewBooking.id;
    const bookingId = selectedReviewBooking.id;
    const commentStarJson = JSON.stringify(ratingCriteria);

    this.setState({ submittingReview: true });
    try {
      // #2 Fixed user_type=guest
      await axios.get(
        `/comments/create?post_id=${postId}&customer_id=${web_user_id}&booking_id=${bookingId}&comment_details=${encodeURIComponent(
          reviewText
        )}&comment_star=${encodeURIComponent(commentStarJson)}&user_type=guest`
      );
      this.setState({ reviewText: "" });
      this.fetchComments(postId, bookingId);
    } catch (error) {
      console.error("Submit review error:", error);
    } finally {
      this.setState({ submittingReview: false });
    }
  };

  calculateAverageRating = (commentStarString) => {
    try {
      const ratings = JSON.parse(commentStarString);
      if (!ratings || ratings.length === 0) return 0;
      const total = ratings.reduce(
        (sum, item) => sum + parseInt(item.value, 10),
        0
      );
      return (total / ratings.length).toFixed(1);
    } catch (e) {
      return 0;
    }
  };

  // =========================================================
  // STATUS CLASSES & UTILS
  // =========================================================

  getStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "confirmed":
        return "booking-status confirmed";
      case "completed":
        return "booking-status completed";
      case "cancelled":
      case "canceled":
        return "booking-status cancelled";
      case "pending":
        return "booking-status pending";
      default:
        return "booking-status";
    }
  };

  getPaymentStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "paid":
      case "completed":
        return "payment-status paid";
      case "pending":
        return "payment-status pending";
      case "unpaid":
      case "failed":
        return "payment-status unpaid";
      default:
        return "payment-status";
    }
  };

  formatDate = (date) => {
    if (!date || date === "N/A") return "N/A";
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return date;
    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  formatPrice = (price) => {
    if (
      price === null ||
      price === undefined ||
      price === "" ||
      price === "N/A"
    ) {
      return "N/A";
    }
    const numericPrice = Number(price);
    if (Number.isNaN(numericPrice)) return price;
    return `৳${numericPrice.toLocaleString("en-BD")}`;
  };

  // =========================================================
  // SVG ICONS
  // =========================================================

  HomeIcon = () => (
    <svg viewBox="0 0 24 24">
      <path
        d="M3 10.8 12 3l9 7.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 9.5V21h13V9.5M9 21v-6h6v6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );

  CalendarIcon = () => (
    <svg viewBox="0 0 24 24">
      <rect
        x="3.5"
        y="5"
        width="17"
        height="15.5"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M7.5 3v4M16.5 3v4M3.5 9.5h17"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );

  UserIcon = () => (
    <svg viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="8"
        r="3.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M5.5 20c.7-3.6 2.8-5.5 6.5-5.5s5.8 1.9 6.5 5.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );

  RefreshIcon = () => (
    <svg viewBox="0 0 24 24">
      <path
        d="M20 11a8 8 0 0 0-14.8-4L3 10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5v5h5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 13a8 8 0 0 0 14.8 4L21 14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 19v-5h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  AlertIcon = () => (
    <svg viewBox="0 0 48 48">
      <circle
        cx="24"
        cy="24"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M24 14v12M24 32v2"
        stroke="currentColor"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
    </svg>
  );

  EmptyIcon = () => (
    <svg viewBox="0 0 80 80">
      <rect
        x="15"
        y="20"
        width="50"
        height="40"
        rx="7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M15 34h50M27 20v-5M53 20v-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M29 46h22M29 53h13"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );

  EditIcon = () => (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  StarIcon = ({ filled = true }) => (
    <svg viewBox="0 0 24 24" fill={filled ? "#f59e0b" : "#cbd5e1"}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );

  PlusIcon = () => (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  TrashIcon = () => (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  CloseIcon = () => (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="m7 7 10 10M17 7 7 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  // =========================================================
  // MOBILE BOOKING CARD
  // =========================================================

  renderMobileBooking = (booking) => {
    return (
      <article className="mobile-booking-card" key={booking.id}>
        <div className="mobile-booking-top">
          <div className="mobile-property-icon">
            <this.HomeIcon />
          </div>

          <div className="mobile-property-heading">
            <span className="mobile-booking-label">BOOKING #{booking.id}</span>

            <h3 title={booking.title} className="mobile-property-title">
              {booking.title}
            </h3>
          </div>

          <span className={this.getStatusClass(booking.booking_status)}>
            <span className="status-dot" />
            {booking.booking_status}
          </span>
        </div>

        {/* STAY */}
        <div className="mobile-stay-box">
          <div className="mobile-date-column">
            <span>CHECK-IN</span>
            <strong>{this.formatDate(booking.checkin_date)}</strong>
          </div>

          <div className="mobile-date-arrow">
            <span />
            <b>›</b>
            <span />
          </div>

          <div className="mobile-date-column right">
            <span>CHECK-OUT</span>
            <strong>{this.formatDate(booking.checkout_date)}</strong>
          </div>
        </div>

        {/* META */}
        <div className="mobile-booking-meta">
          <div className="mobile-meta-item">
            <span className="mobile-meta-icon">
              <this.UserIcon />
            </span>
            <span>
              <small>Guests</small>
              <strong>
                {booking.adults}{" "}
                {Number(booking.adults) === 1 ? "Adult" : "Adults"}
              </strong>
            </span>
          </div>

          <div className="mobile-meta-item">
            <span className="mobile-meta-icon">
              <this.CalendarIcon />
            </span>
            <span>
              <small>Booked on</small>
              <strong>{this.formatDate(booking.booking_date)}</strong>
            </span>
          </div>
        </div>

        {/* FOOTER */}
        <div className="mobile-booking-footer">
          <div>
            <small>Total amount</small>
            <strong className="mobile-price">
              {this.formatPrice(booking.sales_price)}
            </strong>
          </div>

          <div className="mobile-payment">
            <small>Payment</small>
            <span
              className={this.getPaymentStatusClass(booking.payment_status)}
            >
              {booking.payment_status}
            </span>
          </div>
        </div>

        {/* MOBILE REVIEW ACTION */}
        <div className="mobile-booking-actions">
          <button
            type="button"
            className="mobile-review-button"
            onClick={() => this.openReviewPopup(booking)}
          >
            <this.EditIcon />
            <span>Write a review</span>
          </button>
        </div>
      </article>
    );
  };

  // =========================================================
  // REVIEW POPUP WITH DYNAMIC GUEST RATING
  // =========================================================

  renderReviewPopup = () => {
    const {
      selectedReviewBooking,
      showReviewPopup,
      reviewText,
      ratingCriteria,
      newCriteriaLabel,
      comments,
      loadingComments,
      submittingReview,
    } = this.state;

    if (!showReviewPopup || !selectedReviewBooking) return null;

    const defaultIds = [
      1787314725651, 1787346727450, 1787314725652, 1787314725653, 1787314725654,
      1787314725655,
    ];

    return (
      <div className="booking-popup-overlay" onClick={this.closeReviewPopup}>
        <div className="booking-popup" onClick={(e) => e.stopPropagation()}>
          <div className="booking-popup-header">
            <div>
              <span>BOOKING #{selectedReviewBooking.id}</span>
              <h3>Write a Review</h3>
            </div>
            <button
              type="button"
              className="booking-popup-close"
              onClick={this.closeReviewPopup}
              aria-label="Close"
            >
              <this.CloseIcon />
            </button>
          </div>

          <div className="review-form-section">
            {/* DYNAMIC GUESTS RATE SECTION */}
            <div className="rate-guests-container">
              <h4 className="rate-guests-title">Rate Your Stay</h4>

              <div className="rate-criteria-list">
                {ratingCriteria.map((item) => {
                  const currentValue = Number(item.value) || 0;
                  return (
                    <div className="rate-criteria-card" key={item.id}>
                      <div className="rate-criteria-header">
                        <span className="rate-criteria-label">{item.label}</span>
                        {!defaultIds.includes(item.id) && (
                          <button
                            type="button"
                            className="rate-remove-btn"
                            onClick={() => this.handleRemoveCriteria(item.id)}
                          >
                            <this.TrashIcon />
                          </button>
                        )}
                      </div>
                      <div className="rate-stars-row">
                        {[1, 2, 3, 4, 5].map((starNum) => (
                          <button
                            type="button"
                            key={starNum}
                            className={`star-btn ${
                              starNum <= currentValue ? "active" : ""
                            }`}
                            onClick={() =>
                              this.handleStarClick(item.id, starNum)
                            }
                          >
                            <this.StarIcon filled={starNum <= currentValue} />
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* DYNAMIC CRITERIA ADDER */}
              <div className="add-criteria-wrapper">
                <input
                  type="text"
                  className="add-criteria-input"
                  placeholder="Add custom rating behavior..."
                  value={newCriteriaLabel}
                  onChange={this.handleNewCriteriaChange}
                />
                <button
                  type="button"
                  className="add-criteria-btn"
                  onClick={this.handleAddCriteria}
                >
                  <this.PlusIcon />
                  <span>Add</span>
                </button>
              </div>
            </div>

            {/* REVIEW COMMENT TEXTAREA */}
            <div className="review-form-group">
              <textarea
                className="review-textarea"
                placeholder="Share details of your experience with this stay..."
                value={reviewText}
                onChange={this.handleReviewTextChange}
              ></textarea>
            </div>

            <button
              className="review-submit-btn"
              onClick={this.submitReview}
              disabled={submittingReview || !reviewText.trim()}
            >
              {submittingReview ? "Submitting..." : "Submit Review"}
            </button>
          </div>

          {/* COMMENTS LISTING WITH STARS */}
          <div className="comments-section">
            <h4 className="comments-title">All Reviews</h4>

            {loadingComments ? (
              <div className="comments-loading">Loading comments...</div>
            ) : comments.length > 0 ? (
              <div className="comments-list">
                {comments.map((comment) => {
                  const avgRating = this.calculateAverageRating(
                    comment.comment_star
                  );
                  const roundedRating = Math.round(avgRating);

                  return (
                    <div className="comment-item" key={comment.id}>
                      <div className="comment-header">
                        <span className="comment-name">
                          {comment.full_name || "Guest"}
                        </span>
                        <span className="comment-date">
                          {this.formatDate(comment.comment_date)}
                        </span>
                      </div>

                      <div className="comment-rating-row">
                        <div className="comment-stars">
                          {[1, 2, 3, 4, 5].map((starNum) => (
                            <this.StarIcon
                              key={starNum}
                              filled={starNum <= roundedRating}
                            />
                          ))}
                        </div>
                        <span className="comment-rating-text">
                          {avgRating} / 5
                        </span>
                      </div>

                      <div className="comment-text">
                        {comment.comment_details}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="comments-loading">No past reviews found.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // =========================================================
  // DESKTOP TABLE
  // =========================================================

  renderDesktopTable = () => {
    const { bookings } = this.state;

    return (
      <div className="desktop-table-wrapper">
        <div className="desktop-table-scroll">
          <table className="desktop-booking-table">
            <thead>
              <tr>
                <th>Booking</th>
                <th>Property</th>
                <th>Stay</th>
                <th>Guests</th>
                <th>Booking Date</th>
                <th>Amount</th>
                <th>Payment</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {bookings.map((booking) => (
                <tr key={booking.id}>
                  <td>
                    <div className="desktop-booking-id">
                      BKG-{booking.id}
                    </div>
                  </td>

                  <td>
                    <div className="desktop-property">
                      <div className="desktop-property-icon">
                        <this.HomeIcon />
                      </div>
                      <div>
                        <div className="desktop-property-title">
                          {booking.title}
                        </div>
                        <div className="desktop-property-id">
                          Reservation #{booking.id}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="desktop-stay">
                      <div>
                        <span>Check-in</span>
                        <strong>
                          {this.formatDate(booking.checkin_date)}
                        </strong>
                      </div>
                      <div className="desktop-stay-arrow">→</div>
                      <div>
                        <span>Check-out</span>
                        <strong>
                          {this.formatDate(booking.checkout_date)}
                        </strong>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="desktop-guests">
                      <span className="desktop-small-icon">
                        <this.UserIcon />
                      </span>
                      <span>
                        {booking.adults}{" "}
                        {Number(booking.adults) === 1
                          ? "Adult"
                          : "Adults"}
                      </span>
                    </div>
                  </td>

                  <td>
                    <div className="desktop-booking-date">
                      {this.formatDate(booking.booking_date)}
                    </div>
                  </td>

                  <td>
                    <div className="desktop-price">
                      {this.formatPrice(booking.sales_price)}
                    </div>
                  </td>

                  <td>
                    <span
                      className={this.getPaymentStatusClass(
                        booking.payment_status
                      )}
                    >
                      {booking.payment_status}
                    </span>
                  </td>

                  <td>
                    <span
                      className={this.getStatusClass(booking.booking_status)}
                    >
                      <span className="status-dot" />
                      {booking.booking_status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // =========================================================
  // LOADING / ERROR / EMPTY STATES
  // =========================================================

  renderLoading = () => (
    <div className="booking-state">
      <div className="booking-spinner" />
      <h3>Loading bookings</h3>
      <p>Please wait while we load your reservations.</p>
    </div>
  );

  renderError = () => {
    const { error } = this.state;
    return (
      <div className="booking-state booking-error-state">
        <div className="state-icon error-state-icon">
          <this.AlertIcon />
        </div>
        <h3>Unable to load bookings</h3>
        <p>{error}</p>
        <button
          type="button"
          className="booking-action-button"
          onClick={this.fetchBookings}
        >
          <this.RefreshIcon />
          Try Again
        </button>
      </div>
    );
  };

  renderEmpty = () => (
    <div className="booking-state booking-empty-state">
      <div className="state-icon empty-state-icon">
        <this.EmptyIcon />
      </div>
      <span className="empty-badge">No reservations</span>
      <h3>No bookings yet!</h3>
      <p>
        Your next adventure is just a click away! Explore available rooms and
        make your first reservation.
      </p>
      <button
        type="button"
        className="booking-action-button explore-button"
      >
        Explore Rooms
        <span>→</span>
      </button>
    </div>
  );

  // =========================================================
  // RENDER
  // =========================================================

  render() {
    const { bookings, loading, error } = this.state;

    return (
      <div className="booking-view">

        {/* HEADER */}
        <header className="booking-page-header">
          <div className="booking-header-left">
            <div className="booking-header-icon">
              <this.CalendarIcon />
            </div>
            <div>
              <h2 className="booking-title">My Bookings</h2>
              <p className="booking-subtitle">
                View and manage all your bookings in one place.
              </p>
            </div>
          </div>

          {!loading && !error && bookings.length > 0 && (
            <div className="booking-count">
              <strong>{bookings.length}</strong>
              <span>
                {bookings.length === 1 ? "Booking" : "Bookings"}
              </span>
            </div>
          )}
        </header>

        {/* CONTENT */}
        {loading && this.renderLoading()}
        {!loading && error && this.renderError()}
        {!loading && !error && bookings.length === 0 && this.renderEmpty()}

        {!loading && !error && bookings.length > 0 && (
          <>
            <div className="desktop-bookings">
              {this.renderDesktopTable()}
            </div>

            <div className="mobile-bookings">
              {bookings.map(this.renderMobileBooking)}
            </div>
          </>
        )}

        {/* REVIEW POPUP */}
        {this.renderReviewPopup()}

      </div>
    );
  }
}

export default MyBookings;
